// Azure dev environment. Opt in with `ng build --configuration azure` (the Dockerfile does).
// Points the Launchpad at the Identity server deployed to Azure Container Apps (dev, Central India).
import { EnvironmentProviders } from '@angular/core'

export const environment = {
  production: false,
  // Custom domain bound to the ACA Identity app (free managed cert). The value is the discovery
  // document's `issuer` verbatim (trailing slash included).
  oauthIssuer: 'https://identities.dev.sphynch.com/',
  // Same-origin in the cloud: the SPA is served at launchpad.dev.sphynch.com and the nginx edge
  // proxies /api → the Launchpad API container. An empty base makes the data services emit
  // relative `/api/v1/...` URLs (no CORS).
  ecommerceApiBaseUrl: '',
  // No store devtools in the deployed bundle: an empty list here means no import of @ngrx/store-devtools
  // in this build at all, so the build tree-shakes the debugging bytes away.
  storeDevtoolsProviders: [] as EnvironmentProviders[],
}
